/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type InquiryDetailResponseDtoLandSubtypesItem = typeof InquiryDetailResponseDtoLandSubtypesItem[keyof typeof InquiryDetailResponseDtoLandSubtypesItem];


export const InquiryDetailResponseDtoLandSubtypesItem = {
  FAMILY_HOUSE_PLOT: 'FAMILY_HOUSE_PLOT',
  APARTMENT_DEVELOPMENT_PLOT: 'APARTMENT_DEVELOPMENT_PLOT',
  COMMERCIAL_DEVELOPMENT_PLOT: 'COMMERCIAL_DEVELOPMENT_PLOT',
  RECREATIONAL_GARDEN_PLOT: 'RECREATIONAL_GARDEN_PLOT',
  AGRICULTURAL_LAND: 'AGRICULTURAL_LAND',
  VINEYARD: 'VINEYARD',
  ORCHARD: 'ORCHARD',
  FOREST: 'FOREST',
} as const;
